module.exports = __webpack_public_path__ + "3da015973257fd4f573984636791418a.fbx";